/**
 * @name GoogleCaptcha.SS2Model.js
 * @author Anchor Group
 * @author Anchor Group : Kalpa
 * 
 * @since 2025-02-13
 * @file Used to get Google Re-Captcha keys.
 */
define('GoogleCaptcha.SS2Model', ['Backbone', 'Utils'], function (Backbone, Utils) {
    'use strict';
    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath('Modules/GoogleCaptchaModule/SuiteScript2/GoogleCaptchaModule.Service.ss'),
            true
        ),
    });
});
